'use strict';

var validate = require('./validate.js');
var standardPayload_model = require('../standardPayload/standardPayload.model.js');
var index = require('../standardPayload/index.js');

/** This function is meant to act as a wrapper for all events that are fired. The purpose of
 * this function is to call the validator before actually sending any requests. If the validator
 * throws an error, then the payload passed is invalid and we do not send any information.
 *
 * @param name string Name of the event
 * @param {{
 *  context: string,
 *  publisherId: string,
 *  send: function,
 *  eventSchemas: object
 *  ...*
 * }} config Analytics config object which provides meta data
 * @param {object} instance The instance of analytics that has been initialized and has user metadata and client host data
 * @param {object} payload Event payload to validate
 * @returns {Promise}
 */

var fireEvent = (function (_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    config = _ref.config,
    instance = _ref.instance,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload;
  var appContext = config === null || config === void 0 ? void 0 : config.context;
  if (!appContext) {
    console.error('Warning: Must provide context - Event will not fire');
    return null;
  }
  if (!name) {
    console.error('Warning: Must provide name - Event will not fire');
    return null;
  }
  var validatedEventPayload, eventPayload;
  try {
    var _config$eventSchemas, _config$eventSchemas$;
    var standard = index({
      config: config,
      instance: instance,
      payload: payload
    });
    var eventSchema = (_config$eventSchemas = config.eventSchemas) === null || _config$eventSchemas === void 0 ? void 0 : (_config$eventSchemas$ = _config$eventSchemas[config.context]) === null || _config$eventSchemas$ === void 0 ? void 0 : _config$eventSchemas$[name];
    if (!eventSchema) {
      throw new Error('Schema for event does not exist!');
    }
    eventPayload = Object.assign({}, standard, payload);
    validatedEventPayload = validate(eventSchema.keys(standardPayload_model.StandardPayloadFields), eventPayload);
  } catch (e) {
    console.error("\n            Error: [" + e + "] \n\n            Event " + name + " will not fire \n\n            Called with: " + JSON.stringify(eventPayload) + "\n        ");
    return null;
  }
  if (!validatedEventPayload) {
    console.error('Error: Schemas cannot be validated - Event will not fire');
    return null;
  }
  return config.send(Object.assign({
    type: config.context + ":" + name
  }, validatedEventPayload));
});

module.exports = fireEvent;
//# sourceMappingURL=fireEvent.js.map
